<template>
  <div>
    <BlocoFiltroPesquisa
      nome-do-form="GuiasNaoFaturadasForm"
      :dados="linhas"
      :botao-download="true"
      :botao-adicionar="false"
      @pesquisar="pesquisar"
      @download="download"
    >
      <template #form>
        <div class="row">
          <div class="col-xs-8 col-sm-4 col-md-2 col-lg-2">
            <SelecionarData
              id="dataInicial"
              :valor="filtro.dataInicial"
              :validacao="v$.filtro.dataInicial"
              label="Data Início"
              @atualizar="filtro.dataInicial = $event"
            />
          </div>
          <div class="col-xs-8 col-sm-4 col-md-2 col-lg-2">
            <SelecionarData
              id="dataFinal"
              :valor="filtro.dataFinal"
              :validacao="v$.filtro.dataFinal"
              label="Data Fim"
              @atualizar="filtro.dataFinal = $event"
            />
          </div>
        </div>
      </template>
    </BlocoFiltroPesquisa>
    <br />
    <GuiasNaoFaturadasTabela v-if="linhas.length" :linhas="linhas" />
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import moment from 'moment'

import BlocoFiltroPesquisa from '@/componentes/formulario/BlocoFiltroPesquisa'
import SelecionarData from '@/componentes/formulario/SelecionarData'
import { useMenu } from '@/composables/useMenu'
import MensagemServico from '@/servicos/MensagemServico'
import RelatorioServico from '@/servicos/RelatorioServico'

import GuiasNaoFaturadasTabela from './GuiasNaoFaturadasTabela'

const mensagemServico = new MensagemServico()

export default {
  components: {
    GuiasNaoFaturadasTabela,
    BlocoFiltroPesquisa,
    SelecionarData,
  },

  setup() {
    useMenu(75)
    return { v$: useVuelidate() }
  },

  data() {
    return {
      linhas: [],
      nomeResultado: 'linhas',
      servico: new RelatorioServico(),
      filtro: {
        dataInicial: moment().startOf('month'),
        dataFinal: moment().endOf('month'),
      },
    }
  },

  validations: {
    filtro: {
      dataInicial: { required },
      dataFinal: { required },
    },
  },

  computed: {
    filtroFormatado() {
      return {
        dataInicial: moment(this.filtro.dataInicial).format('YYYY-MM-DD'),
        dataFinal: moment(this.filtro.dataFinal).format('YYYY-MM-DD'),
      }
    },
  },

  methods: {
    filtroValido() {
      this.v$.$touch()
      if (this.v$.filtro.$invalid) {
        mensagemServico.alerta('Informe a Data Início e Data Fim.')
        return false
      }
      return true
    },
    pesquisar() {
      if (!this.filtroValido()) return
      this.servico
        .relatorioGuiasNaoFaturadas(this.filtroFormatado)
        .then((res) => {
          if (res?.erro) {
            this.linhas = []
            return
          }
          this.linhas = res ?? []
        })
    },
    download() {
      if (!this.filtroValido()) return
      if (this.linhas.length === 0) {
        mensagemServico.alerta(
          'Não há dados para exportar. Ajuste os filtros e efetue a pesquisa novamente'
        )
        return
      }
      this.servico
        .relatorioGuiasNaoFaturadosDownload(this.filtroFormatado)
        .then((res) => {
          if (res?.erro) return
          const url = window.URL.createObjectURL(new Blob([res]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'guias_nao_faturadas.xlsx')
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
        })
    },
  },
}
</script>
